import { useState, useEffect } from "react";
import { GeneralFooter } from "../../../components/generalFooter/GeneralFooter";
import { MooringMateHomeHeader } from "../../../components/HomeHeader/MooringMateHomeHeader";
import "./PaymentSuccess.css";
import DoneIcon from "@mui/icons-material/Done";
import LockIcon from "@mui/icons-material/Lock";
import { useNavigate, useLoaderData, useSearchParams } from "react-router-dom";
import { paymentStatus, updatePaymentStatus } from "../../../services/payment";
import Typography from "@mui/material/Typography";
import toast from "react-hot-toast";
import { timestampToDateTime } from "../../../utils";
import CircularProgress from "@mui/material/CircularProgress";
import { trackPaymentSuccessful } from "../../../utils/analytics";
import { formatEuroCurrency } from "../../../utils/currency";

export const PaymentSuccess = () => {
  const navigate = useNavigate();
  const user = useLoaderData();
  let [searchParams] = useSearchParams();
  let transactionId = searchParams.get("transaction_id");
  let sessionId = searchParams.get("session_id");
  const [loading, setLoading] = useState(true);
  const [statusData, setStatusData] = useState(null);

  const getPaymentStatus = async () => {
    const res = await paymentStatus(user?.token, sessionId);
    // console.log("payment status res: ", res);

    if (res?.status === true) {
      setStatusData(res?.data);

      // Track successful payment
      trackPaymentSuccessful(transactionId, res?.data?.amount_total / 100);

      setLoading(false);
      return;
    }

    if (res?.status === false) {
      if (res.message === "Invalid or expired access token.") {
        toast.error("Token expired Please re-login and try");
        setLoading(false);
        return;
      }

      toast.error("Something went wrong, please try again later.");
      setLoading(false);
      return;
    }

    toast.error("Something went wrong, please try again later.");
    setLoading(false);
    return;
  };

  const updatedOrderPaymentStatus = async () => {
    const res = await updatePaymentStatus(
      sessionId,
      transactionId,
      user?.token
    );
    // console.log("update status res: ", res);
    if (res?.status === true) {
      toast.success("Payment status updated");
      return;
    }

    if (res?.status === false) {
      if (res.message === "Invalid or expired access token.") {
        toast.error("Token expired Please re-login and try");

        return;
      }

      toast.error("Payment update failed. Contact admin with transaction ID");

      return;
    }

    toast.error("Payment update failed. Contact admin with transaction ID");

    return;
  };

  useEffect(() => {
    if (sessionId) {
      getPaymentStatus();
      updatedOrderPaymentStatus();
      return;
    }
    return;
  }, [sessionId]);

  return (
    <>
      <MooringMateHomeHeader />
      <div className="payContainer">
        {sessionId ? (
          loading ? (
            <div className="loaderParent">
              <CircularProgress />
            </div>
          ) : (
            <div className="success-container">
              <div className="success-icon">
                <DoneIcon sx={{ color: "white" }} fontSize="large" />
              </div>
              <h1 className="successTxt">Payment Successful!</h1>
              <p className="pay-failed-text">
                Thank you for your purchase. Your payment has been processed
                successfully.
              </p>

              <div className="order-details">
                <div className="detail-row">
                  <span className="detail-label">Name :</span>
                  <span className="detail-value">
                    {statusData?.customer_details?.name}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Email :</span>
                  <span className="detail-value">
                    {statusData?.customer_details?.email}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Order ID:</span>
                  <span className="detail-value">{transactionId}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Transaction ID:</span>
                  <span className="detail-value" style={{ overflowX: "scroll" }}>
                    {statusData?.id}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Date & time:</span>
                  <span className="detail-value">
                    {timestampToDateTime(statusData?.created)}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Total Amount:</span>
                  <span className="detail-value">
                    {formatEuroCurrency(statusData?.amount_total / 100)}
                  </span>
                </div>
              </div>

              {/* <p className="pay-failed-text">
              A confirmation email has been sent to your registered email
              address.
            </p> */}

              <button className="btn" onClick={() => navigate("/home")}>
                Continue to Dashboard
              </button>

              <div className="secure-note">
                <LockIcon fontSize="small" />{" "}
                <span> Your payment is secure and encrypted</span>
              </div>
            </div>
          )
        ) : (
          <div style={{ height: "60vh" }}>
            <Typography component="h1" variant="h4" align="center">
              You don't have access to this page
            </Typography>
          </div>
        )}
      </div>
      <GeneralFooter />
    </>
  );
};
